var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM15.3472 8.63996C15.5461 8.83151 15.552 9.14803 15.3605 9.34694L12.8056 12.0001L15.3605 14.6532C15.552 14.8521 15.5461 15.1686 15.3472 15.3602C15.1482 15.5517 14.8317 15.5458 14.6402 15.3468L12.0001 12.6052L9.36016 15.3467C9.16861 15.5456 8.85209 15.5516 8.65318 15.3601C8.45426 15.1685 8.44829 14.852 8.63984 14.6531L11.1947 12L8.63984 9.34682C8.44829 9.14791 8.45426 8.83139 8.65318 8.63984C8.85209 8.4483 9.16861 8.45427 9.36016 8.65318L12.0002 11.3948L14.6402 8.6533C14.8317 8.45439 15.1482 8.44842 15.3472 8.63996Z",
    fill: "#FF3C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.e71dcdce5159713823e075fb8a497a1b.svg";
export { ForwardRef as ReactComponent };